export default {
  'meta': {
    'langName': 'SPANISH',
    'lang': 'Español'
  },
  'title': 'RETIRADA DE PRODUCTO PATINETE ELÉCTRICO BTWIN SD500E O MD500E',
  'description': 'Hola:\n\nHa adquirido un patinete eléctrico de la marca BTWIN, modelo SD500E o MD500E, y te agradecemos tu confianza.\n\nTu seguridad es nuestra prioridad; por favor, lee atentamente la siguiente información.\n\nA pesar de nuestros rigurosos procedimientos de control de calidad, hemos identificado un defecto de seguridad en los patinetes eléctricos BTWIN modelos SD500E y MD500E. El uso intensivo puede provocar la aparición de una grieta en la unión entre el chasis y la potencia. Este defecto puede causar la rotura de dicha unión, lo que conlleva un riesgo de caída para el usuario.\n\nTe sugerimos que respondas a las siguientes preguntas para que podamos ofrecerte una solución de seguridad para tu producto.\n\nTe pedimos disculpas por las molestias ocasionadas y te agradecemos tu confianza.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'En primer lugar, ¿podría confirmar su dirección de correo electrónico y su país de residencia?'
  },
  'fields': {
    'country': 'País',
    'address': 'Correo electrónico',
    'email': 'Correo electrónico',
    'phonePrefix': 'Prefijo telefónico',
    'phone': 'Número de teléfono',
    'validations': {
      'phoneOrEmail': 'Proporcione al menos una dirección de correo electrónico o un número de teléfono.',
      'email': 'Introduzca una dirección de correo válida',
      'phone': 'Introduzca un número de teléfono válido',
      'selectAddress': 'Por favor, seleccione una dirección completa de la lista (número, calle y ciudad).',
      'incompleteAddress': 'La dirección debe incluir número, calle y ciudad. Escriba al menos el número y la calle, y después seleccione una de las sugerencias.'
    },
    'firstName': 'Apellido',
    'lastName': 'Nombre',
    'deliveryAddress': 'Dirección para la entrega del paquete',
    'additionalAddress': 'Datos adicionales para la dirección de entrega',
    'city': 'Cuidad',
    'zip': 'Código portal',
    'readConfirmation': 'Certifico que mis datos de contacto son correctos, reconozco haber leído las condiciones facilitadas y me comprometo a respetarlas',
    'choose': 'Seleccionar',
    'required': 'Este campo es obligatorio',
    'deliveryAddressHelp': 'Introduzca el número y el nombre de su calle, y después seleccione una dirección completa de la lista',
    'streetOnlyHint': 'Añada el número de calle'
  },
  'ownerCheck': {
    'title': '¿Sigue siendo propietario de uno o varios patinetes eléctricos BTWIN SD500E y MD500E?'
  },
  'yes': 'SÍ',
  'no': 'NO',
  'ownerChanged': {
    'title': '¿Tiene los datos de contacto del propietario o propietarios actuales?',
    'confirmation': 'Apreciado/a Sr./Sra:\n\nGracias por participar en esta iniciativa de calidad.\n\nLe pedimos disculpas por las molestias ocasionadas y le agradecemos su confianza.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Por favor indique la cantidad patinetes eléctricos de BTWIN SD500 y  MD500',
    'descriptionSd500': 'Patinetes eléctricos BTWIN SD500 ',
    'descriptionEmd500e': 'patinetes eléctricos MD500',
    'modelNumberHelp': 'Puede encontrar el número de modelo (SD500E o MD500E) en la parte inferior de tu patinete, como se muestra a continuación.',
    'quantity': 'Cantidad',
    'confirmation': 'Gracias por rellenar este formulario. Su solicitud ha sido registrada correctamente.\n\nLe informaremos en un plazo máximo de 20 días sobre la fecha a partir de la cual podrá realizar la reparación.\n\nLe deseamos un excelente día,\n\nDECATHLON'
  },
  'repair': {
    'title': 'Reparación con su participación',
    'description': 'Le rogamos que deje de utilizarlo.\n\nLe enviaremos a su domicilio un kit de reparación junto con las instrucciones para que pueda asegurar su patinete. Este kit se le enviará de forma totalmente gratuita y su montaje es rápido y sencillo.\n\nTras la recogida de su información, nos pondremos en contacto con usted en un plazo máximo de 20 días para confirmarle cuándo estará disponible su kit de reparación. Tenga en cuenta que se hará todo lo posible para reducir estos plazos para su satisfacción.',
    'videoLink': 'Enlace al vídeo',
    'store': 'Enlace al aviso',
    'kitLabel': 'Kit de reparación completo',
    'docLabel': 'Instrucciones de reparación',
    'callToAction': 'Clique aquí para recibir el kit de reparación gratuito',
    'infoConfirmation': 'Por favor, compruebe sus datos',
    'validateConfirmation': 'Confirmar'
  },
  'repairRequest': {
    'title': 'Por favor, rellene la siguiente información para recibir el kit de reparación'
  },
  'form': {
    'submit': 'Siguiente'
  },
  'status': 'Translation validated by COUNTRY'
} as const
